import { Route } from '@angular/router';
//import { HomeComponent } from './components/home/home.component';

export const appRoutes: Route[] = [
   { path: '', redirectTo: '/home', pathMatch: 'full' },
 // { path: 'home', component: HomeComponent },
 { path: 'home', loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent) },
  { path: 'billing', loadComponent: () => import('./components/billing/billing.component').then(m => m.BillingComponent) },
  { path: 'bureau', loadComponent: () => import('./components/bureau/bureau.component').then(m => m.BureauComponent) },
  { path: 'monthly-billing', loadComponent: () => import('./components/monthly-billing/monthly-billing.component').then(m => m.MonthlyBillingComponent) },
    { path: 'reports', loadComponent: () => import('./components/reports/reports.component').then(m => m.ReportsComponent) },
      { path: 'add-new-client', loadComponent: () => import('./components/Add-New-Client/Add-New-Client.component').then(m => m.AddNewClientComponent) },
      { path: 'client-details', loadComponent: () => import('./components/client-details/client-details.component').then(m => m.ClientDetailsComponent) },
     { path: '**', redirectTo: 'home' },
  // ...other routes...
];
